// extracted by mini-css-extract-plugin
module.exports = {"container":"notesList_container__1gVzA","notes-list":"notesList_notes-list__1j1m4","header":"notesList_header__3Rt_m"};